export enum PostMessageRequestOrigin {
  BROWSER = 'BROWSER',
  APP = 'APP',
}
